import { render, staticRenderFns } from "./TemplateDetalhes.vue?vue&type=template&id=2d50aa4a&scoped=true&"
import script from "./TemplateDetalhes.vue?vue&type=script&lang=js&"
export * from "./TemplateDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetalhes.vue?vue&type=style&index=0&id=2d50aa4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50aa4a",
  null
  
)

export default component.exports